<template>
  <v-container fluid class="ma-4 px-8">
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="bulkPaymentReportHeaders.slice(0, -1)"
            :items="reportData"
            fixed-header
            hide-default-footer
          >
            <template v-slot:no-data>
              <div class="text-center">No data available</div>
            </template>
            <template v-slot:[`item.partner_id`]="{ item }">
              {{ getPartnerName(item.partner_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <span class="ml-5 text-5xl font-weight-bold accent--text">
        Payments
      </span>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="computedHeaders"
            :items="reportStudentData"
            fixed-header
          >
            <template v-slot:no-data>
              <div class="text-center">No data available</div>
            </template>
            <template v-slot:[`item.amount_paid`]="{ item }">
              {{ item.amount_paid ? item.amount_paid : item.amount }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  bulkPaymentReportHeaders,
  bulkPaymentStudentHeaders,
} from "@/constants/headers";

export default {
  components: {},
  data() {
    return {
      reportData: [],
      reportStudentData: [],
      bulkPaymentReportHeaders,
      bulkPaymentStudentHeaders,
      partners: [],
      loading: false,
      bulk_payment_id: null,
      payment_type: "",
    };
  },
  computed: {
    computedHeaders() {
      const headers = [];

      if (this.payment_type === "Admission") {
        headers.push(
          {
            text: "Application ID",
            value: "application_id",
            class: "black--text font-weight-bold secondary",
          },
          ...this.bulkPaymentStudentHeaders
        );
      } else {
        headers.push(
          {
            text: "USN",
            value: "usn_id",
            class: "black--text font-weight-bold secondary",
          },
          ...this.bulkPaymentStudentHeaders
        );
      }

      return headers;
    },
  },
  async created() {
    this.bulk_payment_id = this.$route.query?.id;
    this.payment_type = this.$route.query?.payment_type;

    if (!this.bulk_payment_id || !this.payment_type) {
      this.$router.go(-1);
      return;
    }
    await Promise.all([this.getPartners(), this.bulkPayments()]);

    this.$store.commit("setBreadcrumbs", [
      { text: "Bulk Payments", to: { name: "Bulk Payments" } },
      { text: "Payments" },
    ]);
    this.bulkStudentPayments();
  },
  methods: {
    async bulkPayments() {
      this.loading = true;
      await this.$axios
        .get(`/business_partner_bulk_payments/${this.bulk_payment_id}`)
        .then((res) => {
          this.reportData = [res.data.data];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async bulkStudentPayments() {
      this.loading = true;
      let url = null;

      if (this.payment_type == "Admission") {
        url = "/list_student_admit_plan_bulk_payments";
      } else {
        url = "/list_student_invoices_report";
      }
      await this.$axios
        .get(url, {
          params: { bulk_payment_id: this.bulk_payment_id },
        })
        .then((res) => {
          this.reportStudentData = res.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPartners() {
      try {
        const response = await this.$axios.get("/partners");
        this.partners = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getPartnerName(id) {
      const partner = this.partners.find((partner) => partner.id === id);
      return partner ? partner.name : "";
    },
  },
};
</script>

<style scoped></style>
